import React from 'react'

export default ({ ...props }) => (
  <svg {...props} width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M14 8L0.499999 15.7942L0.5 0.205771L14 8Z' fill='#0D0D0D' />
  </svg>
)
